module.exports = __webpack_public_path__ + "static/media/HelpText.b0ae6973.yml";